import React from 'react';
import { Button, Icon } from 'lmc-ui-library';

export const ApproveButton: React.FC<{
  isApproved: boolean;
  onClick: any;
  isLoading: boolean;
  isDisabled: boolean;
}> = ({ isApproved, onClick, isLoading, isDisabled }) => {
  return (
    <Button
      borderVariant="rectangle"
      mode="primary"
      className={`approve-button ${isApproved ? `success` : ``}`}
      onClick={onClick}
      disabled={isLoading || isDisabled}>
      {isApproved && (
        <>
          Approved <Icon type="accept" />
        </>
      )}
      {!isApproved && <>Approve</>}
    </Button>
  );
};

export const DeclineButton: React.FC<{
  isDeclined: boolean;
  onClick: any;
  isLoading: boolean;
  isDisabled: boolean;
}> = ({ isDeclined, onClick, isLoading, isDisabled }) => {
  return (
    <Button
      borderVariant="rectangle"
      mode="ghost"
      className={`decline-button ${isDeclined ? `error` : ``}`}
      onClick={onClick}
      disabled={isLoading || isDisabled}>
      {isDeclined && (
        <>
          Declined <Icon type="error" />
        </>
      )}
      {!isDeclined && <>Decline</>}
    </Button>
  );
};
